import { Svg, SvgPath, SvgProps } from '../../../components/svg';

export function Car(props: SvgProps) {
  return (
    <Svg {...props} viewBox="0 0 15 13" fill="none">
      <SvgPath
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.63727 1.25C3.16443 1.25 2.8027 1.50583 2.67541 1.80284L1.19962 5.24621C1.06365 5.56347 0.69622 5.71044 0.378953 5.57446C0.0616861 5.43849 -0.0852786 5.07106 0.050698 4.75379L1.52648 1.31044C1.87966 0.48636 2.74215 0 3.63727 0H11.3631C12.2582 0 13.1207 0.486356 13.4738 1.31044L14.9496 4.75379C15.0856 5.07106 14.9386 5.43849 14.6214 5.57446C14.3041 5.71044 13.9367 5.56347 13.8007 5.24621L12.3249 1.80285C12.1976 1.50584 11.8359 1.25 11.3631 1.25H3.63727Z"
        fill="#502314"
      />
      <SvgPath
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.000160187 5C0.000160187 4.65482 0.279982 4.375 0.62516 4.375H14.3752C14.7203 4.375 15.0002 4.65482 15.0002 5V10.625C15.0002 10.9702 14.7203 11.25 14.3752 11.25H0.62516C0.279982 11.25 0.000160187 10.9702 0.000160187 10.625V5ZM1.25016 5.625V10H13.7502V5.625H1.25016Z"
        fill="#502314"
      />
      <SvgPath
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.62516 10C0.970338 10 1.25016 10.2798 1.25016 10.625C1.25016 10.2798 1.52998 10 1.87516 10C2.22034 10 2.50016 10.2798 2.50016 10.625V11.875C2.50016 12.2202 2.22034 12.5 1.87516 12.5H0.62516C0.279982 12.5 0.000160187 12.2202 0.000160187 11.875V10.625C0.000160187 10.2798 0.279982 10 0.62516 10Z"
        fill="#502314"
      />
      <SvgPath
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.1252 10C13.4703 10 13.7502 10.2798 13.7502 10.625C13.7502 10.2798 14.03 10 14.3752 10C14.7203 10 15.0002 10.2798 15.0002 10.625V11.875C15.0002 12.2202 14.7203 12.5 14.3752 12.5H13.1252C12.78 12.5 12.5002 12.2202 12.5002 11.875V10.625C12.5002 10.2798 12.78 10 13.1252 10Z"
        fill="#502314"
      />
      <SvgPath
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.87516 7.5C1.87516 6.80964 2.4348 6.25 3.12516 6.25C3.81552 6.25 4.37516 6.80964 4.37516 7.5C4.37516 8.19036 3.81552 8.75 3.12516 8.75C2.4348 8.75 1.87516 8.19036 1.87516 7.5Z"
        fill="#502314"
      />
      <SvgPath
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.6252 7.5C10.6252 6.80964 11.1848 6.25 11.8752 6.25C12.5655 6.25 13.1252 6.80964 13.1252 7.5C13.1252 8.19036 12.5655 8.75 11.8752 8.75C11.1848 8.75 10.6252 8.19036 10.6252 7.5Z"
        fill="#502314"
      />
    </Svg>
  );
}
